<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Накладные на получение</h5>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading.invoices" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading.invoices && invoicesLoaded">
          <table class="table table-sm table-hover">
            <tbody>
            <tr v-for="(i, index) in invoices" :key="i.id" :class="{'bordered_2 extra_drugs_tr': index === 0}">
              <!--              <td>-->
              <!--                <input type="checkbox" v-model="selectedInvoices[i.id]">-->
              <!--              </td>-->
              <td>{{ i.id }}</td>
              <td>{{ i.comment }}</td>
              <td>{{ printDate(i.created_at, 'DD.MM.YYYY') }}</td>
              <td>
                <button class="btn btn-default" @click="getDetails(false, i.id)" type="button">показать накладную
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="mt-1 text-right">
            <LoadingButton
              v-if="Object.keys(selectedInvoices).filter((i) => selectedInvoices[i]).length > 1"
              title="Показать препараты"
              className="btn btn-outline-info "
              :onClick="() => getDetails()"
              :loading="loading.btnLoadInvoiceDetails"
              :color="$constants.PRIMARY_COLOR"
            />
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading.btnLoadInvoiceDetails" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="showInvoiceDetails || loading.invoiceDetails">
      <div class="card">
        <div class="card-body">
          <div class="flex">
            <div class="flex-grow-1">
              <label>Поиск препарата</label>
              <div class="input-group">
                <input @input="onInputSearch" type="text" v-model="searchTitle" class="form-control">
                <div class="input-group-append">
                  <button class="btn btn-default" type="button" @click="() => {
                  searchTitle = '';
                  this.onInputSearch()
                }">Очистить поиск
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <div class="flex justify-content-between">
            <h5>Препараты</h5>
            <div>
              <LoadingButton
                v-if=" selectedManyInvoices && selectedManyInvoices[0] && changeInvoiceStatus === 0"
                title="Начать приемку"
                type="button"
                className="btn btn-primary"
                :onClick="() => updateInvoiceStatus(1)"
                :loading="loading.changeStatusBtn"
                color="white"
              />
              <LoadingButton
                v-if=" selectedManyInvoices && selectedManyInvoices[0] && changeInvoiceStatus === 1"
                title="Остановить приемку "
                type="button"
                className="btn btn-primary"
                :onClick="() => updateInvoiceStatus(0)"
                :loading="loading.changeStatusBtn"
                color="white"
              />
            </div>
            <div>
              <LoadingButton
                v-if="selectedManyInvoices && selectedManyInvoices[0] && changeInvoiceStatus === 3"
                title="Накладная принята"
                type="button"
                className="btn btn-outline-success"
                :onClick="() => passInvoiceToModeration(selectedManyInvoices[0])"
                :loading="loading.invoicesButtons[selectedManyInvoices[0]]"
                :color="$constants.PRIMARY_COLOR"
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <pulse-loader :loading="loading.invoiceDetails" :color="$constants.LOADING_COLOR" class="text-center"/>
          <div v-if="showInvoiceDetails">
            <div class="alert alert-info text-right">
              <h4>Указывайте или добавляйте сроки годности <strong>только</strong> текущего поступления препаратов</h4>
            </div>
            <table class="table table-sm mt-0">
              <thead>
              <tr>
                <th></th>
                <th width="400px">Препарат</th>
                <th></th>
                <th></th>
                <th></th>
                <th>Габариты</th>
                <th>Ожидаемое</th>
                <th>Фактическое</th>
                <th width="180px">Срок годности</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r,i) in filteredRecords" :key="r?.drug?.id"
                  :class="{'bg_danger': +r.qty !== +r.income_qty}">
                <td>{{ i + 1 }}</td>
                <td>
                  <DrugTitleWithImage :drug="r.drug"/>
                  <DrugDimensionInfo :addDimension="() => openDimension(r.drug.id)"
                                     :dimensions="hasDimensionRecords(r.all_details)"/>
                </td>
                <td>
                  <button @click="uploadImages(Object.values(r.details)[0].id)" class="btn btn-outline-info btn-sm flex"
                          type="button">
                    <i class="icon-im icon-im-plus"/>
                    <i class="icon-fa icon-ln icon-ln-photo align-self-center"/>
                  </button>
                </td>
                <td>
                  <template v-if="(r.files ?? []).length">
                    <PreviewPage :files="r.files" :hidePreview="true"/>
                  </template>
                </td>
                <td>
                  {{ r.invoices.length > 1 ? r.invoices : null }}
                </td>
                <td>
                  <template v-if="!showDimensions[r.drug.id]">
                    <button type="button" v-if="!hasDimensionRecords(r.all_details).length"
                            @click="openDimension(r.drug.id)"
                            :class="{'btn': true, 'btn-danger': true}">добавить размеры
                    </button>
                  </template>
                  <CountryDimension ref="countryDimensions" v-else
                                    :drugId="r.drug.id"
                                    :updateRecords="true"
                                    :addEmpty="true"
                                    :onSave="() => getDetails(true, getSelectedInvoice().id)"
                                    :countryId="getSelectedInvoice().country_id"
                                    :records="r.all_details"/>
                </td>
                <td><strong>{{ r.qty }}</strong></td>
                <td class="num_input">
                  <input type="number" @change="updateQty(r)" :disabled="changeInvoiceStatus === 0"
                         v-model="r.income_qty"
                         class="form-control">
                </td>
                <td
                  :class="{'valid_date_warning': alertList.validDates[r.drug.id]}">
                  <!--                                     :updateDates="(d) => expireDates[r.drug.id] = d"-->
                  <ExpireDatesByMask v-if="expDatesLoaded"
                                     :ref="`expire_dates_${r.drug.id}`"
                                     :allToSelectDate="true"
                                     :disableEdit="true"
                                     :invoiceId="getSelectedInvoice().id"
                                     :drug-id="r.drug.id"
                                     :savedDates="savedExpireDates[r.drug.id] ?? {}"
                                     :expireDates="expireDates[r.drug.id] ?? []"/>
                </td>
              </tr>
              <template v-if="loading.searchDrugs || extraDrugsRecords.length > 0">
                <tr class="extra_drugs_tr">
                  <td colspan="10">
                    <template v-if="loading.searchDrugs">
                      <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
                    </template>
                    <template v-else>
                      Препараты, которые соответсвуют поиску и могут быть добавлены в накладную
                    </template>
                  </td>
                </tr>
                <tr v-for="(r,ii) in extraDrugsRecords" :key="r.id">
                  <td>{{ ii + 1 + filteredRecords.length }}</td>
                  <td>
                    <DrugTitleWithImage :drug="r"/>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>0</strong></td>
                  <td class="num_input">
                    <input type="number" @change="updateQty(r)" :disabled="changeInvoiceStatus === 0" v-model="r.qty"
                           class="form-control">
                  </td>
                  <!--                  <td-->
                  <!--                    :class="{'valid_date_warning': changeInvoiceStatus === 3 && expDatesLoaded && !hasSelectedValidDates(r.id)}">-->
                  <!--                    <ExpireDatesByMask v-if="expDatesLoaded"-->
                  <!--                                       :allToSelectDate="true"-->
                  <!--                                       :invoiceId="getSelectedInvoice().id"-->
                  <!--                                       :updateDates="(d) => expireDates[r.id] = d"-->
                  <!--                                       :savedDates="savedExpireDates[r.drug.id] ?? {}"-->
                  <!--                                       :drug-id="r.id"-->
                  <!--                                       :expireDates="expireDates[r.id]"/>-->
                  <!--                  </td>-->
                </tr>
              </template>
              </tbody>
            </table>
            <div class="text-right mt-1">
              <LoadingButton
                v-if="selectedManyInvoices && selectedManyInvoices[0] && changeInvoiceStatus === 3"
                title="Накладная принята"
                type="button"
                className="btn btn-outline-success"
                :onClick="() => passInvoiceToModeration(selectedManyInvoices[0])"
                :loading="loading.invoicesButtons[selectedManyInvoices[0]]"
                :color="$constants.PRIMARY_COLOR"
              />
            </div>
          </div>

        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DrugTitleWithImage from "@/components/drugs/DrugTitleWithImage.vue";
import ExpireDateManage from "@/components/drugs/expireDateManage.vue";
import AddNewDrugWithPhoto from "@/components/invoices/AddNewDrugWithPhoto.vue";
import PreviewPage from "@/components/files/PreviewPage.vue";
import store from "@/store";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";
import ExpireDatesByMask from "@/components/drugs/ExpireDatesByMask.vue";
import moment from 'moment';
import CountryDimension from "@/views/stores/components/CountryDimension.vue";
import DrugDimensionInfo from "@/views/stores/drugs/DrugDimensionInfo.vue";

export default {
  components: {
    DrugDimensionInfo,
    CountryDimension,
    ExpireDatesByMask,
    UploadCustomWithPreview,
    DrugSearchNew, PreviewPage, AddNewDrugWithPhoto, ExpireDateManage, DrugTitleWithImage, LoadingButton
  },
  data() {
    return {
      changeInvoiceStatus: 0,
      extraDrugsRecords: [],
      searchTitle: null,
      invoicesLoaded: false,
      showInvoiceDetails: false,
      expDatesLoaded: false,
      selectedInvoices: {},
      selectedManyInvoices: false,
      loading: {
        changeStatusBtn: false,
        addNewDrug: false,
        invoices: false,
        btnLoadInvoiceDetails: false,
        invoiceDetails: false,
        invoicesButtons: {},
        searchDrugs: false,
      },
      invoices: [],
      records: {},
      showDimensions: {},
      filteredRecords: [],
      expireDates: {},
      savedExpireDates: {},
      alertList: {validDates: {}, dimensions: {}}
    }
  },
  created() {
    this.getInvoices();
  },
  methods: {
    hasDimensionRecords(details) {
      // console.log(details, this.getSelectedInvoice());
      // console.log(details.filter((d) => +d.int_value === this.getSelectedInvoice()?.country_id && d.group_alias === 'country_data' && d.alias === 'dimensions'));
      return details.filter((d) => +d.int_value === this.getSelectedInvoice()?.country_id && d.group_alias === 'country_data' && d.alias === 'dimensions');
    },
    openDimension(id) {
      this.$set(this.showDimensions, id, true);
    },
    getSelectedInvoice() {
      return this.invoices.find((i) => i.id === +Object.keys(this.selectedInvoices)[0]);
    },
    uploadImages(id) {
      store.dispatch("platform/setGlobalModalData", {
        type: 'UploadImagesWithPreview',
        headerText: 'Загрузка фотографий для препарата',
        extraData: {object: 'invoice_detail', objectId: id},
        callBack: async () => {
          await this.getDetails(true);
          store.dispatch("platform/setGlobalModalData", null)
          toastr['success']('Сохранено!')
        }
      });
    },
    onInputSearch(e) {
      this.extraDrugsRecords = [];
      const search = (e?.target?.value ?? '').toLowerCase();
      if (search) {
        this.searchRecords(search, this)
      } else {
        this.filterRecords();
      }
    },
    searchRecords: _.debounce(async (search, vm) => {
      vm.filterRecords(null, search)
    }, 750),
    async addNewDrug() {

    },
    async searchExtraDrugs(search) {
      this.loading.searchDrugs = true;
      const {data} = await api.post('/new/drugs/search', {
        searchTitle: search,
        noPrices: true,
        storeId: null,
        searchOptions: {expireDates: true},
      });
      if (data.success) {
        if (data.drugs.length) {
          const ids = Object.keys(this.records);
          this.extraDrugsRecords = data.drugs.filter((d) => !ids.includes(d.id + ''));
          this.extraDrugsRecords.forEach((d) => {
            d.valid_dates.forEach((vd) => {
              if (vd.is_active) {
                if (!this.expireDates[d.id]) this.expireDates[d.id] = [];
                this.expireDates[d.id].push({
                  ...vd,
                  date: moment(vd.expire_date).format('MM.YYYY')
                })
              }
            })
          });
        }
      }
      this.loading.searchDrugs = false;
    },
    filterRecords(drug = null, search = null, update = false) {
      let allRecords = [...Object.values(this.records)];
      if (!drug) {
        if (search) {
          allRecords = allRecords.filter((r) => r.drug.title.toLowerCase().includes(search) || r.drug.en_title.toLowerCase().includes(search));
          if (search.length > 3) {
            this.searchExtraDrugs(search);
          }
        }
        setTimeout(() => {
          this.filteredRecords = _.orderBy(allRecords, 'drug.title');
        }, 100)
      } else {
        this.filteredRecords = _.orderBy(allRecords.filter((r) => r?.drug?.id === drug.id), 'drug.title');
      }
    },
    async passInvoiceToModeration(id, pass = false) {
      console.log(id);
      this.alertList = {validDates: {}, dimensions: {}};
      const drugs = Object.values(this.records).filter((r) => +r.income_qty !== 0);
      drugs.forEach((d) => {
        if (!this.hasDimensionRecords(d.all_details).length) {
          this.alertList.dimensions[d.drug.id] = d;
        }
        if (!Object.keys(this.$refs[`expire_dates_${d.drug.id}`]?.[0]?.selectedDates ?? {}).filter((date) => this.$refs[`expire_dates_${d.drug.id}`][0].selectedDates[date]).length) {
          this.alertList.validDates[d.drug.id] = d;
        }
      });
      let alert = false;
      let message = '';
      Object.values(this.alertList.validDates).forEach((d, i) => {
        if (i === 0) message += "Укажите сроки годности:\n";
        message += d.drug.title + "\n";
        alert = true;
      });
      if (message) toastr['warning'](message, 'Внимание!');
      message = '';
      Object.values(this.alertList.dimensions).forEach((d, i) => {
        if (i === 0) message += "Укажите габариты:\n";
        message += d.drug.title + "\n";
        alert = true;
      });
      if (message) toastr['warning'](message, 'Внимание!');
      if (alert) return;

      if (!pass) {
        store.dispatch("platform/setGlobalModalData", {
          ...{
            type: 'ConfirmCodeModal',
            callBack: () => this.passInvoiceToModeration(id, true)
          }
        });
        return;
      }
      this.loading.invoicesButtons[id] = true;
      this.loading = {...this.loading};
      const {data} = await api.post('/invoices/updateByAction', {
        action: 'passToQtyModeration',
        invoice_id: id
      })
      if (data.success) {
        store.dispatch("platform/setGlobalModalData", null);
        toastr['success']('Сохранено!')
        this.showInvoiceDetails = false;
        await this.getInvoices(true);
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
      this.loading.invoicesButtons[id] = false;
    },
    async updateQty(record) {
      const selectedInvoices = Object.keys(this.selectedInvoices).filter((i) => this.selectedInvoices[i]);
      if (!selectedInvoices.length) {
        toastr['warning']('Накладные не выбраны');
        return;
      }
      const {data} = await api.post('/invoices/updateByAction', {
        action: 'updateIncomeQtyInvoices',
        drug_id: record?.drug?.id ?? record.id,
        invoices: selectedInvoices,
        total_income: record.income_qty
      })
      if (data.success) {
        if (!record?.drug?.id) {
          await this.getDetails(true);
        } else {
          this.updateChangeStatus();
        }
        toastr['success']('Обновлено!')
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
    },
    async getExpDates() {
      const {data} = await api.post('/drugs/expireDatesById', {
        drugsIds: Object.keys(this.records)
      });
      if (data.success) {
        const expireDates = data.records.reduce((acc, r) => {
          if (!acc[r.drug_id]) acc[r.drug_id] = [];
          r.date = moment(r.expire_date).format('MM.YYYY');
          r.timestamp = moment(r.expire_date).unix();
          acc[r.drug_id].push(r);
          return acc;
        }, {})
        Object.keys(expireDates).forEach((id) => {
          expireDates[id] = _.orderBy(expireDates[id], 'timestamp', 'asc');
        })
        Object.keys(this.records).forEach((k) => {
          // if (!this.expireDates[k]) this.expireDates[k] = [{date: ''}];
          if (!expireDates[k]) expireDates[k] = [];
        })
        this.expireDates = expireDates;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки сроков годности');
      }
      this.expDatesLoaded = true;
    },
    async getDetails(silent = false, id = null) {
      let selected = [];
      if (id) {
        selected.push(id);
        this.selectedInvoices = {[id]: true};
      } else {
        selected = Object.keys(this.selectedInvoices).filter((k) => this.selectedInvoices[k]);
      }
      if (!selected.length) {
        toastr['warning']('Выберите накладные', 'Ошибка');
        return;
      }

      if (!silent) {
        this.extraDrugsRecords = [];
        this.searchTitle = null;
      }
      this.loading.btnLoadInvoiceDetails = !silent;
      this.showInvoiceDetails = silent;
      this.expDatesLoaded = silent;
      const {data} = await api.post('/invoices/getInvoices', {
        type: 'grouped',
        extra_options: ['dimensions'],
        selectedInvoices: selected
      });
      if (data.success) {
        if (silent) {
          Object.keys(this.showDimensions).forEach((k) => this.showDimensions[k] = false);
        }
        this.records = Object.keys(data.records).reduce((acc1, k) => {
          data.records[k].income_qty = Object.values(data.records[k].details).reduce((acc, d) => acc + +(d.income_qty ?? 0), 0);
          acc1[k] = data.records[k]
          return acc1;
        }, {});
        this.savedExpireDates = Object.values(data.records).reduce((acc, r) => {
          Object.values(r.details).forEach((d) => {
            (d?.extra_data?.expire_dates ?? []).forEach((e) => {
              if (!acc[r.drug.id]) acc[r.drug.id] = {};
              acc[r.drug.id][e] = true;
            })
          });
          return acc;
        }, {})
        this.filterRecords(null, this.searchTitle);
        this.showInvoiceDetails = true;
        this.selectedManyInvoices = selected;
        this.getExpDates();
        this.updateChangeStatus();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.btnLoadInvoiceDetails = false;
    },
    async getInvoices(silent = false) {
      this.loading.invoices = !silent;
      const {data} = await api.index('/invoices/type?type=foreignIncomeT');
      if (data.success) {
        this.invoices = _.orderBy(data.records, 'id', 'asc');
        this.invoicesLoaded = true;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.invoices = false;
    },
    async updateInvoiceStatus(changeStatus) {
      let newStatus = 7;
      switch (+changeStatus) {
        case 0:
          newStatus = 5
          break;
      }
      this.loading.changeStatusBtn = true;
      const invoiceId = Object.keys(this.selectedInvoices).filter((i) => this.selectedInvoices[i])[0];
      const currentStatus = this.invoices.find((i) => i.id === +invoiceId).status;
      const {data} = await api.post('/invoices/updateByAction', {
        action: 'updateStatus',
        invoice_id: invoiceId,
        currentStatus,
        newStatus
      })
      if (data.success) {
        await this.getInvoices(true);
        await this.getDetails(true);
        this.updateChangeStatus();
        toastr['success']('Обновлено!')
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.changeStatusBtn = false;
    },
    updateChangeStatus() {
      this.changeInvoiceStatus = 0;
      const selected = Object.keys(this.selectedInvoices).filter((k) => this.selectedInvoices[k]);
      let selectedInvoice = null;
      if (selected.length === 1) {
        selectedInvoice = this.invoices.find((i) => i.id === +selected[0]);
      }
      if (!selectedInvoice) return;
      if (+selectedInvoice.status === 5) this.changeInvoiceStatus = 0;
      if (+selectedInvoice.status === 7) {
        this.changeInvoiceStatus = 1;
        const recordUpdated = Object.values(this.records).find((r) => +r.income_qty !== 0);
        if (recordUpdated) {
          this.changeInvoiceStatus = 3;
        }
      }
    }
  }
}

</script>

<style scoped>
.num_input input {
  width: 70px;
}

.extra_drugs_tr {
  background-color: #efffef;
}

.valid_date_warning {
  background-color: #ffcfcf;
}

.bordered_2 {
  border: 2px solid gray;
}
</style>
